import React from 'react';
import '../assets/css/Services.css';
import service1 from '../assets/images/services/service1.png';
import service2 from '../assets/images/services/service2.png';
import service3 from '../assets/images/services/service3.png';
import service4 from '../assets/images/services/service4.png';
import service5 from '../assets/images/services/service5.png';

function Services() {
  const services = [
    {
      id: 1,
      title: 'ARCHITECTURAL DESIGN AND PLANNING',
      description: 'Custom steel structures and components for residential and commercial projects',
      image: service1
    },
    {
      id: 2,
      title: 'GENERAL CONTRACTING',
      description: 'Complete construction services from foundation to finishing',
      image: service2
    },
    {
      id: 3,
      title: 'STRUCTURAL WORKS',
      description: 'Expert structural design and consultation for complex projects',
      image: service3
    },
    {
      id: 4,
      title: 'FIT-OUT WORKS AND FINISHING WORKS',
      description: 'Comprehensive renovation and restoration of existing structures',
      image: service4
    },
    {
      id: 5,
      title: 'ADS',
      description: 'Installation and Delivery for Adgraphix',
      image: service5
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <h2>Design and Construction Services</h2>
        <p className="section-subtitle">We provide comprehensive construction and steel services</p>
        <div className="services-grid">
          {services.map(service => (
            <div 
              key={service.id} 
              className="service-card"
              style={{ backgroundImage: `url(${service.image})` }}
            >
              <div className="service-overlay">
                <div className="service-content">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
